<template lang="pug">
.flow-left
	h1.mb-3 {{tip.title}}
	v-responsive.mb-3(:aspect-ratio="16/9")
		vue-plyr(v-if="tip.video.videoSource === 'youtube' || tip.video.videoSource === 'vimeo'" ref='plyr' :options='{"controls":["play", "progress", "volume", "play-large", "airplay", "fullscreen", "pip", "mute"], "disableContextMenu": false}' :key="tip.video.videoId")
			div(:data-plyr-provider='tip.video.videoSource' :data-plyr-embed-id='tip.video.videoId')
		video-hls(v-else-if="tip.video.videoSource === 'video'" :videoUrl="tip.video.videoId")
	ws-content(:markdown="tip.content.markdown" :level="2" v-if="tip.content")

</template>
<script>
import gql from 'graphql-tag';

const query = gql`
	query getTipTrickBySlug($slug: String!) {
		tip: tiptrickBySlug(slug: $slug) {
			id
			title
			slug
			type
			content {
				markdown
				introduction(length: 145)
			}
			video {
				id
				thumb
				videoId
				videoSource
			}
		}
	}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/tips-en-tricks/:slug',
			'nl-BE': '/tips-en-tricks/:slug'
		}
	},
	asyncData({ params, app, error }) {
		return app.$graphClient
			.query({
				query,
				variables: {
					slug: params.slug
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				if (!data.tip) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				app.meta({
					title: data.tip.title,
					description: data.tip.content.introduction,
					hasFollow: true,
					hasIndex: true
				});
				app.ads({ sidebar: { visible: true } });
				app.breadcrumbs({
					[app.i18n.t('page.videos:breadcrumb')]: { name: 'videos' },
					[app.i18n.t('page.videos.breadcrumb:tips.tricks')]: {
						name: 'videos-tipstricks'
					},
					[data.tip.title]: {
						name: 'videos-tipstricks-slug'
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'videos-tipstricks-index-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
